export const navLinks = [
  { label: "Work", href: "#work" },
  { label: "Studio", href: "#studio" },
  { label: "Services", href: "#services" },
  { label: "Journal", href: "#journal" },
  { label: "Contact", href: "#contact" },
];

export const heroCopy = {
  headline: "Design\u00a0 brands forward.",
  description: "Brand systems built for clarity and impact.",
  cta: { label: "View work", href: "#work" },
};

export const services = [
  { number: "01", title: "Brand Strategy" },
  { number: "02", title: "Digital Design" },
  { number: "03", title: "Web Development" },
  { number: "04", title: "Content Design" },
];